import React from 'react'
import axios from 'axios'
import './index.less'
import { wsInit, wsSendMsg, wsColsed } from '@/assets/wsUtils/GetTdDataFun'
import { getParams } from '@/assets/js/utils'
class GoldTD extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            imgURL: require('./../../../assets/images/GoldTDbutton.png'),
            goldTDList: [],
            goldTDButton: null,
            soketParam: [],
            goldTd_params: getParams().soure
        }
    }

    componentDidMount () {
        this.getTitleDetails()
    }

    componentWillUnmount () {
        wsColsed()
    }

    async connectSocket () {
        await wsInit(this.getWsPushMsg)
        await wsSendMsg('["Au(T+D)","mAu(T+D)","Ag(T+D)"]')
    }

  getTitleDetails = () => {
      let cms_api = ''
      // 因代理调不通，则暂时手写代理
      if (process.env.REACT_APP_NODE_ENV !== 'production') {
          cms_api = '//cms.gomegold.com'
      // cms_api = "//gold-cms.gomeuat.com.cn";
      // cms_api = "//finance-api-uat.gomegold.com";
      // cms_api = "//gold-cms-uat.gomefinance.com.cn";
      } else {
          cms_api = '//cms.gomegold.com'
      }
      const getGoldTDList = [] // soket传参
      const parms = this.state.goldTd_params === 'plus' ? 'gome.app' : 'finance.app'
      axios
          .get(
              `${cms_api}/banner/bannerListPage?keyWord=LC-hangqing&version=2.2.2&platform=${parms}`
          )
          .then((res) => {
              console.log(res)
              if (res.data.result && res.data.result.bannerElements) {
                  res.data.result.bannerElements.forEach((item, index) => {
                      if (item.remark !== 'button') {
                          const obj = Object.assign(item, {
                              latestPrice: '',
                              lastSettle: '',
                              upsDownsQuota: '',
                              upsDownsRange: '',
                              upsDownsFlag: ''
                          })
                          getGoldTDList.push(obj)
                      } else {
                          this.setState({
                              goldTDButton: item
                          })
                      }
                  })
                  console.log(getGoldTDList)
                  this.setState({
                      goldTDList: getGoldTDList
                  })
                  this.connectSocket()
              }
          })
  };

  getWsPushMsg = (res) => {
      const sUserID = res.sUserID.replace(/\s/g, '')
      const sBody = this.regroupData(res.sBody)
      const obj = JSON.parse(JSON.stringify(this.state.goldTDList))
      obj.forEach((item) => {
          if (item.remark === sUserID) {
              item.latestPrice = sBody.last || item.latestPrice
              item.lastSettle = sBody.lastSettle || item.lastSettle
              item.upsDownsQuota = sBody.upDown || item.upsDownsQuota
              // item.upsDownsFlag = item.latestPrice - item.lastSettle >= 0 ? true : false ;
              item.upsDownsFlag = item.upsDownsQuota >= 0
              item.upsDownsRange = sBody.upDownRate || item.upsDownsRange
          }
      })
      this.setState({
          goldTDList: obj
      })
  };

  regroupData = (arr) => {
      var obj = {}
      if (Array.isArray(arr)) {
          for (var i = 0; i < arr.length; i++) {
              obj[arr[i][0]] = arr[i][1]
          }
      }
      return obj
  };

  handleNextPage = (url) => {
      if (url) {
          window.location.href = url
      }
  };

  render () {
      const { data: { position, trackId }, buriedPointEvent } = this.props
      const { goldTDList, imgURL, goldTDButton } = this.state
      return (
          <React.Fragment>
              {goldTDList.length && (
                  <div className="GoldTD_Box">
                      <div className="GoldTD_content">
                          <ul className="content_top">
                              {goldTDList && goldTDList.map((item, index) => (
                                  <li
                                      className="content_line"
                                      key={item.id}
                                      onClick={() => {
                                          buriedPointEvent({
                                              button_name: `${trackId}-${item.elementTitle}`,
                                              button_id: `${item.id}`,
                                              button_order: `${index + 1}`,
                                              area_order: position,
                                              button_area: `${position}-${trackId}`
                                          })
                                          this.handleNextPage(item.tolink)
                                      }}
                                  >
                                      {index === 1 ? (
                                          <React.Fragment>
                                              <span className="content_line_tipsLeft"></span>
                                              <span className="content_line_tipsRight"></span>
                                          </React.Fragment>
                                      ) : null}

                                      <p className="content_title">{item.elementTitle}</p>
                                      <p className="content_subTitle">{item.remark}</p>
                                      <p className="content_amount">{item.latestPrice}</p>
                                      <div className="content_rate">
                                          <span className="rate_left">
                                              {item.upsDownsFlag ? '+' : '-'}
                                              {item.upsDownsQuota !== ''
                                                  ? Number(item.upsDownsQuota) !== 0
                                                      ? Math.abs(item.upsDownsQuota).toFixed(2)
                                                      : '0.00'
                                                  : '--'} %
                                          </span>
                                          <span className="rate_right">
                                              {item.upsDownsFlag ? '+' : '-'}
                                              {item.upsDownsRange !== ''
                                                  ? Number(item.upsDownsRange) !== 0
                                                      ? Math.abs(item.upsDownsRange).toFixed(2)
                                                      : '0.00'
                                                  : '--'} %
                                          </span>
                                      </div>
                                  </li>
                              ))}
                          </ul>

                          <div className="content_bottom">
                              <img
                                  src={imgURL}
                                  className="bottom_button"
                                  onClick={() => {
                                      buriedPointEvent({
                                          button_name: `${trackId}-立即交易`,
                                          button_id: `${this.props.data.id}`,
                                          button_order: '1',
                                          area_order: position,
                                          button_area: `${position}-${trackId}`
                                      })
                                      this.handleNextPage(goldTDButton.tolink)
                                  }}
                              />
                          </div>
                      </div>
                  </div>
              )}
          </React.Fragment>
      )
  }
}
export default GoldTD
